/* tslint:disable:no-shadowed-variable */
import { GetterTree } from 'vuex'
import { ProfileState } from './types'
import { RootState } from '@/store/types'


const DEFAULT_LOCALE = 'en-US'

export const getters: GetterTree<ProfileState, RootState> = {
  fullName (state): string {
    const { user } = state
    const firstName = user && user.firstName
    const lastName = user && user.lastName
    return [firstName, lastName].filter(x => x).join(' ')
  },
  locale (state): string {
    const { user } = state
    return user && user.locale || DEFAULT_LOCALE
  },
  lang (_, getters): string {
    return getters.locale.split('-')[0]
  },
  region (_, getters): string {
    return getters.locale.split('-')[1]
  },
  retrieveUser: () => {
    const value = window.sessionStorage.getItem('user')
    return value && JSON.parse(value)
  },
  isAuthenticated: state => () => {
    const { user } = state
    const expiresOn = user && user.expiresOn || ''

    // Checks whether the loaded user has not expired
    return Date.now() < Date.parse(expiresOn)
  }
}
